import { FieldType } from '@wix/wix-data-schema-types'
import {
  CHECKBOX_GROUP_ROLE,
  USER_INPUT_FILTER_V1_ROLE,
  USER_INPUT_FILTER_CHECKBOX_GROUP_ROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { stringArray, text, number, reference } = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Checkbox_Group',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 228,
    title: 'Connect_Panel_Title_Checkbox_Group',
    helpId: '1525c097-d872-4e67-aba7-2faae9c346e9',
    chooseScreenHelpId: 'e48b4bed-2670-49d0-983d-62656940de95',
    submitContentHelpId: '0402c0d0-4008-418a-ae93-d1c93542d22a',
    userInputFilterHelpId: 'fb2f5350-217f-4246-bd34-af72cfc64cc0',
  },
  sections: [
    {
      role: CHECKBOX_GROUP_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Value_Label',
          prop: 'value',
          supportedFieldTypes: [stringArray],
          defaultFieldType: stringArray,
          isInputProperty: true,
          emptyValue: [],
        },
      ],
    },
    {
      role: USER_INPUT_FILTER_V1_ROLE,
      bindings: [],
      componentTypeName:
        'Connect_Panel_Dataset_Filter_Message_Element_Type_MultiSelect',
    },
    {
      role: USER_INPUT_FILTER_CHECKBOX_GROUP_ROLE,
      isUserInputFilter: true,
      bindings: [
        {
          prop: 'value',
          supportedFieldTypes: [text, number, stringArray, reference],
          defaultFieldType: text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId:
                'user_input_filters_live_preview_gfpp_desktop_main_action',
              label: 'User_Input_Filters_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
        panel: {
          settings: {
            controls: {
              required: {
                hidden: true,
              },
            },
          },
        },
      },
      manageContentPanel: {
        isElementNamePlural: true,
      },
    },
  ],
  compactErrorPanel: true,
})
